import script from "./Instructions.vue?vue&type=script&setup=true&lang=js"
export * from "./Instructions.vue?vue&type=script&setup=true&lang=js"

import "./Instructions.vue?vue&type=style&index=0&id=06fde1c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06fde1c0"]])

export default __exports__